document.addEventListener("turbo:load", function () {
  // Find all Calendly widgets on the page
  const calendlyWidgets = document.querySelectorAll("[data-calendly-widget]");

  if (calendlyWidgets.length === 0) return;

  // Load Calendly script dynamically only when needed
  loadCalendlyScript().then(() => {
    calendlyWidgets.forEach(initializeCalendlyWidget);
  }).catch((error) => {
    console.error("Failed to load Calendly widget:", error);
    calendlyWidgets.forEach(showCalendlyFallback);
  });
});

function loadCalendlyScript() {
  return new Promise((resolve, reject) => {
    // Check if Calendly is already loaded
    if (window.Calendly) {
      resolve();
      return;
    }

    // Check if script is already being loaded
    if (document.querySelector('script[src*="calendly.com"]')) {
      // Wait for existing script to load
      const checkCalendly = setInterval(() => {
        if (window.Calendly) {
          clearInterval(checkCalendly);
          resolve();
        }
      }, 100);

      // Timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkCalendly);
        reject(new Error("Calendly script load timeout"));
      }, 10000);
      return;
    }

    // Create and load the script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Calendly script"));

    document.head.appendChild(script);
  });
}

function initializeCalendlyWidget(widget) {
  const url = widget.dataset.calendlyWidget;
  const options = {
    height: parseInt(widget.dataset.height) || 700,
    hideEventTypeDetails: widget.dataset.hideEventTypeDetails === "true",
    hideGdprBanner: widget.dataset.hideGdprBanner === "true"
  };

  try {
    // Clear any existing content
    widget.innerHTML = "";

    // Initialize Calendly widget
    window.Calendly.initInlineWidget({
      url: url,
      parentElement: widget,
      ...options
    });

    // Add loaded class for styling
    widget.classList.add("calendly-loaded");

  } catch (error) {
    console.error("Failed to initialize Calendly widget:", error);
    showCalendlyFallback(widget);
  }
}

function showCalendlyFallback(widget) {
  const url = widget.dataset.calendlyWidget;
  const fallbackContent = `
    <div class="calendly-fallback alert alert-info">
      <h5>Terminbuchung</h5>
      <p>Der Terminkalender konnte nicht geladen werden.</p>
      <a href="${url}" target="_blank" rel="noopener" class="btn btn-primary">
        Termin direkt bei Calendly buchen
      </a>
    </div>
  `;

  widget.innerHTML = fallbackContent;
  widget.classList.add("calendly-error");
}